import 'react-app-polyfill/stable'
import queryString from 'query-string'
import ReactDOM from 'react-dom'
import * as serviceWorkerRegistration from './serviceWorkerRegistration'
import BTPPage from './components/btpPage'
import { name, version } from '../package.json'
import './index.scss'

// eslint-disable-next-line no-console
console.log(`${name}.v.${version}`)

const qs = queryString.parse(window.location.search, { parseBooleans: true })
const params = {
    duration: Number(qs?.d ?? '10'),
    amount: Number(qs?.q ?? '1'),
    ...(qs?.m && { msgId: qs.m }),
    ...(qs?.l && { loop: qs.l }),
    ...(qs?.p && { preview: qs.p }),
}

ReactDOM.render(
    <BTPPage
        msgId={params.msgId}
        duration={params.duration}
        amount={params.amount}
        loop={params.loop}
        preview={params.preview}
    />,
    document.getElementById('root'),
)

serviceWorkerRegistration.register()
